module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account/password/password.component.css
// module id = ./src/app/account/password/password.component.css
// module chunks = main